<div class="modal-dialog">

  <div class="modal-content">
    <div class="modal-header">Finalize PO?</div>
    <div class="modal-body">

      @if (poItemsInitial && poItemsInitial.length > 0) {
        <div class="cl-form">
          <label for="itempreselect" class="form-label">Select which PO Items to publish</label>
          <select id="itempreselect" class="form-select" [(ngModel)]="publicationMode" (change)="publicationChanged()">
            <option value="all">Force re-publication of all PO Items.</option>
            <option value="unpublished">Publish all unpublished PO Items.</option>
            <option value="poonly">Do not publish any PO Items.</option>
            <option value="selected">Publish selected PO Items.</option>
          </select>
          @if (poItems) {
            <div class="course-detail">
              <p class="mt-3">PO Items to be published</p>
              <div class="cl-spacing-box-micro">
                @for (poitem of poItemsInitial; track poitem) {
                  <input type="checkbox" class="cl-toggle-checkbox" [id]="'poitem-' + poitem.po_item_id"
                    [checked]="isSelected(poitem)"
                    (change)="toggle(poitem)">
                  <label class="cl-badge" [for]="'poitem-' + poitem.po_item_id">
                    <i class="fas fa-check fa-fw"></i>
                    <i class="fas fa-times fa-fw"></i>
                    {{ poitem.po_item_id }}
                  </label>
                }
              </div>
            </div>
          } @else {
            <div style="top:calc(50%);position: absolute; overflow: hidden; left: calc(50% - 48px) ; z-index: 3">
              <div>
                <div class="cl-spinner"><i class="fas fa-spinner fa-spin"></i></div>
              </div>
            </div>
          }
        </div>
      }
      @if (loadError) {
        <p class="alert cl-alert-danger" role="alert">Could not load the PO items: {{ loadError }}</p>
      } @else if (!poItems || poItems.length == 0) {
        <div style="display: flex; flex-direction: column; align-self: center">
          <div style="text-align: center">
            <img width="125" src="assets/emptystates/NoTasks.png"/>
          </div>
          <div class="cl-h3" style="text-align: center">No PO items to publish</div>
        </div>
      }

    </div>
    <div class="modal-footer">
      <app-form-footer label="Finalize PO" (action)="publish($event)" [disabled]="!poItems || poItems.length === 0">
        <button footerStart type="button" class="btn cl-color-secondary it-cancel" (click)="dialogRef.close()"><span>Close</span></button>
      </app-form-footer>
    </div>
  </div>
</div>
